


























































import { Component, Watch, Vue, Emit } from 'vue-property-decorator';
import { companyServer, doublePrevention, institutionServer, patrolManagementServe, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component
export default class PatrolPointEdit extends Vue {
  private visible = false;
  private type = '';

  private spaceData: any = []; // 单位列表
  private spaceAreaTree: any = []; // 区域列表

  private riskPointAndDangerSourceList: any = []; // 风险点、危险源
  private riskPointList: any = []; // 风险点
  private dangerSourceList: any = []; // 危险源

  private patrolEquipList: any = []; // 巡检点code列表
  private enterpriseData: any = []; // 企业列表

  private form: any = {
    name: '',
    spaceAreaId: '',
    sort: 100,
    code: '',
    spaceId: '',
    riskPointId: '',
    dangerSourceId: '',
    companyId: '',
    companyName: '',
  };
  private companyType: any = '';
  private pointRules: any = {
    name: [{ required: true, message: '请输入巡检点名称', trigger: 'blur' }],
    spaceAreaId: [{ required: true, message: '请选择区域', trigger: 'change' }],
    riskPointId: [{ required: true, message: '请选择风险点', trigger: 'change' }],
  };
  private _showOnce = false;

  /**
   * 窗口标题
   * @Params
   * @return
   **/
  get title() {
    const typeMap: any = {
      add: '添加巡检点',
      edit: '编辑巡检点',
    };
    return typeMap[this.type];
  }

  created() {}

  private changeArea(e: any) {
    this.form.riskPointId = '';
    this.riskPointList = [];
    this.form.dangerSourceId = '';
    this.dangerSourceList = [];
    this.form.companyId = '';
    this.form.companyName = '';
    this.companyType = '';
    if (e) {
      this.getRiskAndDangerSourceData();
    }
  }

  private changeRiskPoint(e: any) {
    this.form.dangerSourceId = '';
    this.dangerSourceList = [];
    this.form.companyId = '';
    this.form.companyName = '';
    this.companyType = '';
    if (e) {
      const findData: any = this.riskPointList.find((item: any) => item.id === e);
      this.form.companyId = findData.companyId;
      this.form.companyName = findData.companyName;
      this.companyType = findData.companyPlaceType;
      this.dangerSourceList = this.riskPointAndDangerSourceList.filter((item: any) => item.type === '危险源' && item.pid === e);
    }
  }

  // 风险点列表
  getRiskAndDangerSourceData() {
    doublePrevention
      .getRiskAll({
        areaId: this.form.spaceAreaId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.riskPointAndDangerSourceList = res.data;
          this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
          if (this.form.riskPointId) {
            this.dangerSourceList = res.data.filter((item: any) => item.type === '危险源' && item.pid === this.form.riskPointId);
          }
        } else {
          this.$message.warning('获取区域的列表失败！');
        }
      });
  }

  /**
   * 【接口】获取企业列表
   */
  private getEnterpriseDataList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'NINE_SMALL_PLACE',
      })
      .then((res: any) => {
        this.enterpriseData = res.data;
      });
  }
  companyChange(e: any) {
    if (e) {
      this.form.companyName = this.enterpriseData.find((item: any) => item.id === e).companyName;
    }
  }

  /**
   * 【接口】获取单位列表
   */
  private getCompanyDataList() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        if (res.code === '200') {
          this.spaceData = res.data;
        } else {
          this.$message.warning('获取数据失败，请稍后重试！');
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败，请稍后重试！');
      });
  }

  spaceChange(e: any) {
    this.form.spaceAreaId = '';
    this.form.code = '';
    this.getSpaceAreaListAll({
      paging: false,
      spaceId: e,
    });
    this.getPatrolEquipAll({
      paging: false,
      spaceId: e,
    });
  }

  /**
   * 打开新增窗口
   * @Params
   * @return
   **/
  async showAddDialog() {
    this.form = {
      name: '',
      spaceAreaId: '',
      sort: 100,
      code: '',
      spaceId: '',
      riskPointId: '',
      dangerSourceId: '',
      companyId: '',
      companyName: '',
    };
    this.riskPointAndDangerSourceList = [];
    this.type = 'add';
    this.visible = true;
    this.getCompanyDataList();
    this.getEnterpriseDataList();
    this.getSpaceAreaListAll({
      paging: false,
    });
    this.getPatrolEquipAll({
      paging: false,
    });
  }

  /**
   * 打开编辑窗口
   * @Params
   * @return
   **/
  showEditDialog(id: string) {
    this.type = 'edit';
    this.getCompanyDataList();
    this.getEnterpriseDataList();
    // try {
    this.visible = true;
    this.getPointData(id);
    // } catch (e) {}
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.resetForm();
    this.visible = false;
  }

  /**
   * 检查巡检点是否被绑定
   */
  checkPointBind() {
    const arrObj = this.patrolEquipList;
    try {
      arrObj.forEach((item: any) => {
        if (item.code == this.form.code) {
          this.form.code = '';
          if (item.bindStatus) {
            this.$confirm('该巡检点已经被绑定,是否从原来绑定的设备上解除绑定，重新绑定现在的设备?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                this.form.code = item.code;
              })
              .catch(() => {});
          } else {
            this.form.code = item.code;
          }
          throw new Error();
        }
      });
    } catch (e) {}
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      switch (this.type) {
        case 'add':
          this.addPointData();
          break;
        case 'edit':
          this.editPointData();
          break;
      }
    });
  }

  /**
   *【表单】表单重置
   * @Params
   * @return
   **/
  resetForm() {
    this.form = {
      name: '',
      spaceAreaId: '',
      sort: 100,
      code: '',
      spaceId: '',
      riskPointId: '',
      dangerSourceId: '',
      companyId: '',
      companyName: '',
    };
    this.riskPointAndDangerSourceList = [];
    this.riskPointList = [];
    this.dangerSourceList = [];
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
  }

  /**
   *【接口】获取巡检点详情
   * @Params
   * @return
   **/
  async getPointData(id: string) {
    this.form.loading = true;
    try {
      const res: any = await patrolManagementServe.getPatrolPointInfoData(id);
      if (res.code === '200') {
        this.form = {
          id: res.data.id,
          name: res.data.name,
          spaceAreaId: res.data.spaceAreaId,
          sort: res.data.sort,
          code: res.data.code,
          spaceId: res.data.spaceId,
          riskPointId: res.data.riskPointId,
          dangerSourceId: res.data.dangerSourceId,
          companyId: res.data.companyId,
          companyName: res.data.companyName,
        };
        this.companyType = res.data.companyPlaceType;
        if (res.data.spaceAreaId) {
          this.getRiskAndDangerSourceData();
        }
        await this.getSpaceAreaListAll({ spaceId: res.data.spaceId, paging: false });
        await this.getPatrolEquipAll({ spaceId: res.data.spaceId, paging: false });
        this.form.loading = false;
        return res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】添加巡检点
   * @Params
   * @return
   **/
  async addPointData() {
    try {
      const res: any = await patrolManagementServe.addPatrolPoint(this.form);
      if (res.code == '200') {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功添加了记录。');
      } else {
        this.$message.warning(res.msg);
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   *【接口】编辑巡检点
   * @Params
   * @return
   **/
  async editPointData() {
    try {
      const res: any = await patrolManagementServe.editPatrolPointData(this.form.id, this.form);
      if (res.code == '200') {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功编辑记录。');
      } else {
        this.$message.warning(res.msg);
        throw new Error();
      }
      return;
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】获取全部区域列表
   * @Params
   * @return
   **/
  async getSpaceAreaListAll(opts: object) {
    try {
      const res: any = await regionServe.getRegionAllData(opts);
      if (res.code === '200') {
        this.spaceAreaTree = arrayToTree(res.data);
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】获取全部该空间下的所有巡检设备
   */
  async getPatrolEquipAll(opts: object) {
    try {
      const res: any = await patrolManagementServe.getPatrolEquipData(opts);
      if (res.code === '200') {
        this.patrolEquipList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }
  /**
   * 【监听】风险点
   */
  @Watch('form.riskPointId')
  onRiskPointChange(val: any, oldVal: any) {
    console.log(val, '4444444444444444444444444444');
  }

  /**
   * 【广播】广播提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
